<template>
  <div>

    <form class="evollu-form">
      <!-- Flow Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('leads-web.flows.flow_details') }}
        </h5>
      </div>

      <div class="row col-12" style="margin-bottom: 0 !important;">
        <!-- input name -->
        <div class="row col-md-6 ml-0">
          <div class="col-12">
            <va-input
              id="name"
              v-model="value.name"
              :disabled="!isUpdating"
              :label="$t('leads-web.table_headings.flow_name')"
              :placeholder="$t('leads-web.table_headings.flow_name')"
              @input="formErrors.clear('name')"
            />

            <small v-show="formErrors.has('name')" class="help text-danger">
              {{ $t(formErrors.get('name')) }}
            </small>
          </div>
        </div>
        <!-- --- --->

        <!-- client name -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{ $t('leads-web.table_headings.client') }}</label>
            <multiselect
              :disabled="!isUpdating"
              :options="entities"
              id="client"
              v-model="value.client"
              label="name"
              track-by="id"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('client')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('client')" class="help text-danger">
              {{ $t(formErrors.get('client')) }}
            </small>
          </div>
        </div>
        <!-- --- --->

      </div>

      <div class="row col-12" style="margin-bottom: 0 !important;">
        <!-- lang -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{ $t('leads-web.table_headings.language') }}</label>
            <multiselect
              :disabled="!isUpdating"
              :options="langOptions"
              id="lang"
              v-model="value.lang"
              :custom-label="opt => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
              track-by="lang"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('lang')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('lang')" class="help text-danger">
              {{ $t(formErrors.get('lang')) }}
            </small>
          </div>
        </div>
        <!-- --- --->

        <!-- country -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{ $t('leads-web.table_headings.country') }}</label>
            <multiselect
              :disabled="!isUpdating"
              :options="countries"
              id="country"
              v-model="value.country"
              :custom-label="opt => opt.name ? opt.name : 'N/A'"
              track-by="code"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('country')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('country')" class="help text-danger">
              {{ $t(formErrors.get('country')) }}
            </small>
          </div>
        </div>
        <!-- --- --->

      </div>

      <div class="row col-12" style="margin-bottom: 0 !important;">
        <div class="row col-md-6 ml-0">
          <div class="col-12">
            <DatePicker
              :disabled="!isUpdating"
              id="date-picker-start_date"
              placeholder="---"
              v-model="value.start_date"
              :label="$t('leads-web.table_headings.start_date')"
              :config="datePickerConfig"
              @input="formErrors.clear('start_date')"/>
            <small v-show="formErrors.has('start_date')" class="help text-danger">
              {{ $t(formErrors.get('start_date')) }}
            </small>
          </div>
        </div>

        <div class="row col-md-6 ml-0">
          <div class="col-12">
            <DatePicker
              :disabled="!isUpdating"
              id="date-picker-end_date"
              placeholder="---"
              v-model="value.end_date"
              :label="$t('leads-web.table_headings.end_date')"
              :config="datePickerConfig"
              @input="formErrors.clear('end_date')"/>
            <small v-show="formErrors.has('end_date')" class="help text-danger">
              {{ $t(formErrors.get('end_date')) }}
            </small>
          </div>
        </div>
      </div>
      <!------------>

    </form>
  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import Multiselect from 'vue-multiselect'
import {mapState} from "vuex";
import DatePicker from "@/components/common/DatePicker";
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'
import * as countries from "i18n-iso-countries";
import Vue from "vue";
export default {
  components: {DatePicker, Multiselect},
  props: {
    entities: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    langOptions: {
      type: Array,
      required: true
    },
    isUpdating: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object,
      required: false
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

  },
  computed: {
    datePickerConfig: function () {
      let config = {
        enableTime: true,
        time_24hr: true,
        minuteIncrement: 15,
        dateFormat: 'Y-m-d H:i',
        defaultHour: '09'
      }

      if (this.$i18n.locale() === 'pt') {
        config.locale = PTLocale
      } else if (this.$i18n.locale() === 'es') {
        config.locale = ESLocale
      } else {
        config.locale = { firstDayOfWeek: 1 }
      }
      return config
    },

  },

}
</script>

<style scoped>
.btn_add {
  padding: 0 !important;
}

.layout.gutter--xl .row:not(:only-child) {
  margin: unset !important;
}
.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}

.custom-multiselect {
  padding-left: 0 !important;
  padding-right: 45px !important;
}

.placeholder-label {
  color:  rgba(194, 194, 194, 0.55)
}
.sort-icon-disabled {
  opacity: 0.2;
}
</style>

<style lang="scss">
@import "~vuestic-ui/src/components/vuestic-sass/vuestic-styles";

.header-lbl{
  padding-left: 5px;
  color: $evollu-dark;
}
</style>
